/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

/**
 * - BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_LOOKUP_FAILED: Book related
 - BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_ID_NOT_FOUND: Authentication related
 - BOOK_CONNECTION_CONDITION_REASON_CODE_CONFIGURATION_UNKNOWN_KEY: Configuration related
 - BOOK_CONNECTION_CONDITION_REASON_CODE_REPLICA_COUNT_IS_ZERO: Connection related
 - BOOK_CONNECTION_CONDITION_REASON_CODE_DISCOVER_IN_PROGRESS: Discover related
 */
export type V2BookConnectionConditionReasonCode =
  (typeof V2BookConnectionConditionReasonCode)[keyof typeof V2BookConnectionConditionReasonCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V2BookConnectionConditionReasonCode = {
  BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_LOOKUP_FAILED:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_LOOKUP_FAILED',
  BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_NOT_FOUND:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_NOT_FOUND',
  BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_MISSING_IMAGE:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_MISSING_IMAGE',
  BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_RUNTIME_VERSION_OUTDATED:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_BOOK_RUNTIME_VERSION_OUTDATED',
  BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_ID_NOT_FOUND:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_ID_NOT_FOUND',
  BOOK_CONNECTION_CONDITION_REASON_CODE_MISSING_CREDENTIAL:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_MISSING_CREDENTIAL',
  BOOK_CONNECTION_CONDITION_REASON_CODE_WRONG_CREDENTIAL_TYPE:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_WRONG_CREDENTIAL_TYPE',
  BOOK_CONNECTION_CONDITION_REASON_CODE_SECRET_NOT_FOUND:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_SECRET_NOT_FOUND',
  BOOK_CONNECTION_CONDITION_REASON_CODE_SECRET_MISSING_KEY:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_SECRET_MISSING_KEY',
  BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_REQUIRED_MISSING:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_REQUIRED_MISSING',
  BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_TEST_FAILED:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_AUTHENTICATION_TEST_FAILED',
  BOOK_CONNECTION_CONDITION_REASON_CODE_TOKEN_REFRESH_FAILED:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_TOKEN_REFRESH_FAILED',
  BOOK_CONNECTION_CONDITION_REASON_CODE_CONFIGURATION_UNKNOWN_KEY:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_CONFIGURATION_UNKNOWN_KEY',
  BOOK_CONNECTION_CONDITION_REASON_CODE_CONFIGURATION_WRONG_TYPE:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_CONFIGURATION_WRONG_TYPE',
  BOOK_CONNECTION_CONDITION_REASON_CODE_REPLICA_COUNT_IS_ZERO:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_REPLICA_COUNT_IS_ZERO',
  BOOK_CONNECTION_CONDITION_REASON_CODE_NEW_DEPLOYMENT_ROLLED_OUT:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_NEW_DEPLOYMENT_ROLLED_OUT',
  BOOK_CONNECTION_CONDITION_REASON_CODE_DISCOVER_IN_PROGRESS:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_DISCOVER_IN_PROGRESS',
  BOOK_CONNECTION_CONDITION_REASON_CODE_DISCOVER_FAILED:
    'BOOK_CONNECTION_CONDITION_REASON_CODE_DISCOVER_FAILED',
} as const;
